import React from 'react';
import {
  SolarSystemLoading,
  WaveTopBottomLoading,
  WindMillLoading,
} from 'react-loadingg';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

export const Backdrops = (props) => {
  const classes = useStyles();
  const { open,handleClose } = props;
  return (
    <div>
      <Backdrop className={classes.backdrop} open={open} onClick={handleClose}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

export const SolarSystemLoadings = () => <SolarSystemLoading />;
export const WaveTopBottomLoadings = () => <WaveTopBottomLoading />;
export const WindMillLoadings = () => <WindMillLoading />;
export const CommonLoadings = () => {
  return (
    <div
      style={{
        zIndex: '5000',
        position: 'fixed',
        width: '100%',
        height: '100%',
        left: 0,
        top: 0,
        background: '#333333',
        opacity: '0.5',
      }}
    >
      <SolarSystemLoadings />
    </div>
  );
};
